import React from 'react';
import { Outlet } from 'react-router-dom';
import mainLogo from '../../assets/image/auth-img/main.png';
import { useLanguage } from '../../features/language/useLanguage';
import { StagingBadge } from '../common/StagingBadge';

export const AuthLayout: React.FC = () => {
  const webVersion = import.meta.env.VITE_WEB_VERSION || 'v0.0.0';
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-test-id="auth-layout">
      <div className="sm:mx-auto sm:w-full sm:max-w-lg">
        <div className="flex justify-center mt-6">
          <img src={mainLogo} alt={t('auth.brandLogoAlt')} className="h-18 w-auto" />
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <Outlet />
        </div>
      </div>
      <div className="mt-6 text-center text-xs font-medium text-gray-500">
        {webVersion}
      </div>
      <StagingBadge />
    </div>
  );
};
